import { AfterViewInit, Component, ViewChild, OnInit, ElementRef } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { element } from 'protractor';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import * as xlsx from 'xlsx';
import { Router } from '@angular/router';


export interface Production {
  production: string;
  category: string;
  qty: number;
  unit: string;
  value: string
}

export interface Consumption {
  material: string;
  category: string;
  expected: number;
  materialissue: number;
  unit: string;
  excess: string;
  expcost: number;
  actcost: number;
}


const ELEMENT_DATA: Production[] = [
  {
    production: 'Pencil', category: '	transistor', qty: 1, unit: 'count',
    value: 'Raw Material'
  },
  {
    production: '0.37 GAL. FINE WIRE', category: 'ABCDE', qty: 3, unit: 'kg',
    value: 'Raw Material'
  },

  {
    production: 'pen', category: 'ABCDE', qty: 3, unit: ' piece(s)',
    value: 'Product'
  },
  {
    production: 'Pencil', category: 'ABCDE', qty: 1, unit: 'count',
    value: 'Raw Material'
  },
  {
    production: '0.37 GAL. FINE WIRE', category: 'ABCDE', qty: 3, unit: 'kg',
    value: 'Raw Material'
  },

  {
    production: 'pen', category: '	Garments', qty: 3, unit: ' piece(s)',
    value: 'Product'
  },
  {
    production: 'Pencil', category: '	transistor', qty: 1, unit: 'count',
    value: 'Raw Material'
  },
  {
    production: '0.37 GAL. FINE WIRE', category: 'ABCDE', qty: 3, unit: 'kg',
    value: 'Raw Material'
  },

  {
    production: 'pen', category: 'ABCDE', qty: 3, unit: ' piece(s)',
    value: 'Product'
  },
];

const ProELEMENT_DATA: Consumption[] = [
  {
    material: 'Pencil', category: '	transistor', expected: 1, materialissue: 3, unit: 'count',
    excess: 'Raw Material', expcost: 3, actcost: 9
  },
  {
    material: '0.37 GAL. FINE WIRE', category: 'ABCDE', expected: 3, materialissue: 7, unit: 'kg',
    excess: 'Raw Material', expcost: 3, actcost: 9
  },

  {
    material: 'pen', category: 'ABCDE', expected: 3, materialissue: 6, unit: ' piece(s)',
    excess: 'Product', expcost: 3, actcost: 9
  },
  {
    material: 'Pencil', category: 'ABCDE', expected: 1, materialissue: 8, unit: 'count',
    excess: 'Raw Material', expcost: 3, actcost: 9
  },
  {
    material: '0.37 GAL. FINE WIRE', category: 'ABCDE', expected: 3, materialissue: 6, unit: 'kg',
    excess: 'Raw Material', expcost: 3, actcost: 9
  },

  {
    material: 'pen', category: '	Garments', expected: 3, materialissue: 8, unit: ' piece(s)',
    excess: 'Product', expcost: 3, actcost: 9
  },
  {
    material: 'Pencil', category: '	transistor', expected: 1, materialissue: 8, unit: 'count',
    excess: 'Raw Material', expcost: 3, actcost: 9
  },
  {
    material: '0.37 GAL. FINE WIRE', category: 'ABCDE', expected: 3, materialissue: 8, unit: 'kg',
    excess: 'Raw Material', expcost: 3, actcost: 9
  },

  {
    material: 'pen', category: 'ABCDE', expected: 3, materialissue: 8, unit: ' piece(s)',
    excess: 'Product', expcost: 3, actcost: 9
  },
];


@Component({
  selector: 'app-consumption-analysis',
  templateUrl: './consumption-analysis.component.html',
  styleUrls: ['./consumption-analysis.component.scss']
})
export class ConsumptionAnalysisComponent implements OnInit {

  displayedColumns: string[] = ['production', 'category', 'qty', 'unit', 'value'];
  displayedColumns1: string[] = ['material', 'category', 'expected','materialissue' ,'unit', 'excess','actcost'];
  dataSource = new MatTableDataSource<Production>(ELEMENT_DATA);
  dataSource1 = new MatTableDataSource<Consumption>(ProELEMENT_DATA);
  // storeList: store[] = [];
  //subCategoryList: subCategory[] = [];
  //categories: category[] = [];
  copyItems: any = [];

  StoreCtrl = new FormControl();
  subCategoryCtrl = new FormControl();

  //filterStore!: Observable<store[]>;
  //filteredsubCategoryList!: Observable<subCategory[]>;
  //filteredCategory!: Observable<category[]>;

  filter: any = 0;


  @ViewChild('epltable', { static: false }) epltable!: ElementRef;
  @ViewChild(MatSort) sort!: MatSort;


  @ViewChild(MatPaginator)
  set paginator(value: MatPaginator) {
    this.dataSource.paginator = value;
  }

  item: any;

  constructor(private router: Router) {
  }

  data: any = {
    ItemName: '',
    ItemID: 0,
    code: '',
    typeID: 1,
    categoryID: 0,
    subCategory: '',
    SubCategoryID: 0,
    category: '',
    Qty: '',
    Unit: 'no.s',
    purchaseCost: '',
    salePrice: '',
    stockRate: '',
    minStockQty: '',
    isAvailable: true,
    showOnline: true,
    isActive: true,
    importanceID: 1,
    HSN: '',
    HSNId: 0,
    brochureLink: '',
    fileLink: '',
    description: '',
    tag: '',
    leadTime: '',
    prcn: 0,
    storeName: '',
    storeID: '',
    IsMade: false,
    IsPurchased: false

  }

  store: any;

  ngOnInit(): void {
    this.dataSource.sort = this.sort;
  }


  exportToExcel() {
    const ws: xlsx.WorkSheet =
      xlsx.utils.table_to_sheet(this.epltable.nativeElement);
    const wb: xlsx.WorkBook = xlsx.utils.book_new();

    xlsx.utils.book_append_sheet(wb, ws, 'Sheet1');
    xlsx.writeFile(wb, 'Stock.xlsx');
  }

  // selectStore = () => {
  //   let tempStore = this.storeList.filter((x: any) => x.sNm == this.data.storeName);
  //   if (tempStore.length > 0) {
  //     this.data.storeID = tempStore[0].StrID
  //   }
  //   else {
  //     this.data.storeID = 0;
  //     this.data.storeName = ""
  //   }
  // }

  // private _filterStore(value: string): store[] {
  //   const filterValue = value.toLowerCase();
  //   return this.storeList.filter(state => state.sNm.toLowerCase().indexOf(filterValue) === 0);
  // }


  // selectCategory = () => {
  //   this.subCategoryList = [];
  //   if (this.data.category) {
  //     let tempCat = this.categories.filter((x: any) => x.cnm == this.data.category)
  //     if (tempCat.length > 0) {
  //       this.data.categoryID = tempCat[0].cid
  //       this.subCategoryList = tempCat[0].sub

  //       this.filteredsubCategoryList = this.subCategoryCtrl.valueChanges
  //         .pipe(
  //           startWith(''),
  //           map(employee => employee ? this._filterSubcategory(employee) : this.subCategoryList.slice())
  //         );


  //     } else {
  //       alert("Please configure category.")
  //       this.data.category = '';
  //       this.subCategoryList = [];
  //       this.data.subCategory = '';
  //     }

  //   }
  // }

  // private _filterSubcategory(value: string): subCategory[] {
  //   const filterValue = value.toLowerCase();
  //   return this.subCategoryList.filter(state => state.snm.toLowerCase().indexOf(filterValue) === 0);
  // }

  // search(searchvalue: string) {
  //  
  //   console.log("serach value:", searchvalue);
  //   for (var i = 0; i < this.empdata; i++) {
  //     if (searchvalue == this.empdata[i].store) {
  //       this.dataSource.filter = this.empdata[i].store;
  //     }
  //   }

  //}

  //common search
  // applyFilter(event: Event) {
  //  
  //   console.log(event);
  //   const filterValue = (event.target as HTMLInputElement).value;
  //   this.dataSource.filter = filterValue.trim().toLowerCase();
  // }

  typeFilter = (obj: any) => {
    var copyItems = this.copyItems
    var tempItem = [];
    this.filter = obj
    if (obj == 0) {
      tempItem = this.copyItems;
    }
    else if (obj == 1) {
      tempItem = copyItems.filter((x: any) => x.TypeID == 1);
    }
    else if (obj == 2) {
      tempItem = copyItems.filter((x: any) => x.TypeID == 2);
    }
    else if (obj == 3) {
      tempItem = copyItems.filter((x: any) => x.TypeID == 3);
    }
    else if (obj == 4) {
      tempItem = copyItems.filter((x: any) => x.TypeID == 4);
    }
    // else if (obj == 5) {
    //   tempItem = copyItems.filter((x: any) => x.TypeID == 5);
    // }

    // this.Items = tempItem
    // this.dataSource.data = this.Items
    // //this.dataSource.filterPredicate = this.createFilter();
    // this.totalValue = 0;

    // for (let i = 0; i < this.Items.length; i++) {
    //   this.totalValue = this.totalValue + this.Items[i].ValStdCost
  }

  backBtn() {
    this.router.navigate(['/Stock']);
  }
}



